import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";
import { Text } from "@meditect/medibase-components";

export const RolesCannotEditOwnerRoleFloorError: ErrorMessageComponent<Record<string, never>> = () => {
  return (
    <Text as="span" mr={1}>
      Le nom de ce rôle et ses permissions cœur (gestion des rôles, des membres, de la pharmacie) ne peuvent pas être
      modifiés. Le reste des permissions reste éditable.
    </Text>
  );
};
